( function( $, moment ) {
    "use strict";

    var BookingRepresentationRelease = {
        WINDOW_RESIZE_DELAY : 100,
        events : {}
    };

    BookingRepresentationRelease.events.onShow = function () {
        var $component = $(this);

        $component
            .removeClass('hidden')
            .trigger('adjust.booking-representation-release');

        $(window).on('resize.booking-representation-release', BookingRepresentationRelease.events.onResizeWindow);

        if (! $component.data('booking-representation-release.state')) {
            $component.trigger('fetch.booking-representation-release');
        }
    };

    BookingRepresentationRelease.events.onHide = function () {
        $(window).off('resize.booking-representation-release');
        $('body').css({overflow: 'auto'});
        $(this).addClass('hidden');
    };

    BookingRepresentationRelease.events.onAdjust = function () {
        var $component = $(this),
            $dialog = $component.find('[booking-representation-release-dialog]'),
            $header = $component.find('[booking-representation-release-header]'),
            $content = $component.find('[booking-representation-release-content]');

            $dialog.css({marginTop : '0'});
            $dialog.height('auto');
            $content.height('auto');

            if ($dialog.outerHeight() / $(window).height() > 0.8) {
                var dialogVerticalSpace = $dialog.outerHeight() - $dialog.height();

                $dialog.height($(window).height() - dialogVerticalSpace * 2);
                $content.height($dialog.height() - $header.outerHeight());
            }

            var marginTop = ($(window).height() - $dialog.outerHeight()) / 2;
            $dialog.css({marginTop : marginTop+'px'});

            $('body').css({overflow: 'hidden'});
    };

    BookingRepresentationRelease.events.onFetch = function () {
        var $body = $('body'),
            $component = $(this),
            $title = $component.find('[booking-representation-release-title]'),
            $content = $component.find('[booking-representation-release-content]'),
            bookingId = $component.data('booking-id');

        $component.addClass('loading').data('booking-representation-release.state', 'loading')

        $body.data('App').showLoading();

        $.App.api('GET', 'bookings/'+bookingId+'/representation-releases')
            .done(function(response) {
                if (! response.success) return;

                $title.html(response.title);
                $content.html(response.content);

                $component.data('booking-representation-release.state', 'loaded');

                if ($component.is(':visible')) {
                    $component.trigger('adjust.booking-representation-release');
                }
            })
            .always(function() {
                $component.removeClass('loading');
                $body.data('App').hideLoading();
            });
    };

    BookingRepresentationRelease.events.onClickShow = function () {
        var $show = $(this),
            $component = $('[booking-representation-release="'+$show.attr('booking-representation-release-show')+'"]');

        $component
            .data('booking-id', $show.data('booking-id'))
            .trigger('show.booking-representation-release');
    };

    BookingRepresentationRelease.events.onClickHide = function () {
        $(this).closest('[booking-representation-release]').trigger('hide.booking-representation-release');
    };

    BookingRepresentationRelease.events.onSelect = function () {
        var $body = $('body'),
            $choice = $(this),
            $component = $choice.closest('[booking-representation-release]'),
            bookingId = $component.data('booking-id');

        if (! $choice.prop('checked')) return;

        $component.addClass('loading').data('booking-representation-release.state', 'loading')

        $body.data('App').showLoading();

        $.App.api('POST', 'bookings/'+bookingId+'/released-representations', {'representation' : $choice.val()})
            .done(function(response) {
                if (! response.success) return;

                $component.data('booking-representation-release.state', 'loaded');
                $component.trigger('hide.booking-representation-release');

                window.location.assign(response.booking_url);
                // window.location.ajaxReload();
            })
            .always(function() {
                $component.removeClass('loading');
            });
    };

    BookingRepresentationRelease.events.onResizeWindow = function () {
        var $window = $(this);

        clearTimeout($window.data('booking-representation-release.resize-timeout'));

        $window.data('booking-representation-release.resize-timeout', setTimeout(function () {
            $('[booking-representation-release]').trigger('adjust.booking-representation-release');
        }, BookingRepresentationRelease.WINDOW_RESIZE_DELAY));
    };

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container),
            $show = $('[booking-representation-release-show]'),
            $component = $container.find('[booking-representation-release]'),
            $hide = $component.find('[booking-representation-release-hide]'),
            $overlay = $component.find('[booking-representation-release-overlay]'),
            choiceSelector = 'input[type="radio"][booking-representation-release-choice]';

        $component
            .on('show.booking-representation-release', BookingRepresentationRelease.events.onShow)
            .on('hide.booking-representation-release', BookingRepresentationRelease.events.onHide)
            .on('fetch.booking-representation-release', BookingRepresentationRelease.events.onFetch)
            .on('adjust.booking-representation-release', BookingRepresentationRelease.events.onAdjust)
            .on('click.booking-representation-release', choiceSelector, BookingRepresentationRelease.events.onSelect);

        $show.on('click.booking-representation-release', BookingRepresentationRelease.events.onClickShow);
        $hide.on('click.booking-representation-release', BookingRepresentationRelease.events.onClickHide);
        $overlay.on('click.booking-representation-release', BookingRepresentationRelease.events.onClickHide);
    });

} ( require('jquery') ) );
